import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA service worker — app-shell offline. Yalnız production build'de kayıt olur
// (dev/preview'da hot-reload ile çakışmaması için). Veri-offline (katalog/arama/satış
// kuyruğu) her ortamda IndexedDB ile zaten çalışır.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    // Yeni SW kontrolü ele alınca sayfayı BİR KEZ yenile → her deploy sonrası taze uygulama
    // (ilk kurulumda yenileme yok; yalnız güncelleme senaryosunda).
    const hadController = !!navigator.serviceWorker.controller;
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hadController || reloaded) return;
      reloaded = true;
      window.location.reload();
    });

    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      const promote = (w) => {
        if (!w) return;
        w.addEventListener("statechange", () => {
          // Yeni sürüm kuruldu ve mevcut bir kontrolör varsa → hemen devral (kullanıcı taze görür).
          if (w.state === "installed" && navigator.serviceWorker.controller) w.postMessage("SKIP_WAITING");
        });
      };
      if (reg.waiting && navigator.serviceWorker.controller) reg.waiting.postMessage("SKIP_WAITING");
      reg.addEventListener("updatefound", () => promote(reg.installing));
      // Sekmeye dönünce / uygulamayı yeniden açınca en güncel SW'yi kontrol et.
      const check = () => { if (document.visibilityState === "visible") reg.update().catch(() => {}); };
      document.addEventListener("visibilitychange", check);
      setInterval(check, 60 * 60 * 1000);
    }).catch(() => {});
  });
}
